import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Injectable,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  NgbActiveModal,
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerModule,
  NgbDateStruct,
  NgbModal,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { CustomLandingModule } from '../../../custom-landing.module';
import { FileUploader, FileUploadModule } from 'ng2-file-upload';
import { ToastrService } from 'ngx-toastr';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { NavigationExtras, Router } from '@angular/router';
import { I18nModule, TranslationService } from '@spartacus/core';
import { RecordPickupConfirmpopupComponent } from '../record-pickup-confirmpopup/record-pickup-confirmpopup.component';
import { SharedModule } from 'src/app/shared/shared.module';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      const date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : '';
  }
}
@Component({
  selector: 'app-dvl-tracking-record-pick-up-modal',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CustomLandingModule,
    NgbDatepickerModule,
    FileUploadModule,
    I18nModule,
    NgbTooltipModule,
    SharedModule,
  ],
  templateUrl: './dvl-tracking-record-pick-up-modal.component.html',
  styleUrl: './dvl-tracking-record-pick-up-modal.component.scss',
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class DvlTrackingRecordPickUpModalComponent implements OnInit {
  form: FormGroup;
  processing: boolean;
  fileSize: any;
  fileName: any;
  filesLength: any;
  filesDetail: any;
  formData: any;
  deliveryCompleted: any;
  docValues: { id: string; Name: string }[];
  uploaddoc: boolean = false;
  fileArray = [];
  base64: any;
  enableLoader: boolean = true;
  selected = false;
  isHidden = false;
  arrayBuffer!: any;
  revalidateClicked: boolean = false;
  @Output() fileadded = new EventEmitter<string>();
  @Input() nominationData;
  @Input() isInvoiceCreationSuccess = false;
  @Input() azureValidationRemark;
  @Input() azureStatus;
  showNextButton: boolean = false;
  transportModes: any[];
  isDisabled: boolean;
  @Input() deliveryDetails;
  uploadErr: boolean = false;
  emptysaveErr: boolean = false;
  // validateMessage = false
  showRevalidate : boolean = false;
  signatures = {
    JVBERi0: 'application/pdf',
    R0lGODdh: 'image/gif',
    R0lGODlh: 'image/gif',
    iVBORw0KGgo: 'image/png',
    '/9j/': 'image/jpg',
  };
  @Input() passingArray: any[];
  dvldDetails: any;
  showReload: boolean = false;
  constructor(
    public ActiveModal: NgbActiveModal,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private customProfile: CustomProfileService,
    private router: Router,
    private translationService: TranslationService,
    private modalService: NgbModal,
    private customProfileService: CustomProfileService,
    private translation: TranslationService,
  ) {}

  detectMimeType(b64) {
    for (var s in this.signatures) {
      if (b64.indexOf(s) === 0) {
        return this.signatures[s];
      }
    }
  }
  ngOnInit(): void {
    this.enableLoader = true;
    let toastshown = false;
    this.customProfile.getMasterDataForDvl('DELT').subscribe({
      next: (res) => {
        this.transportModes = res.transportModes;
        this.enableLoader = false;
      },
      error: (err) => {
        this.enableLoader = false;
        this.translationService
          .translate('shipment.erroroccuredmessage')
          .subscribe({
            next: (res) => {
              if (!toastshown) {
                this.toastrService.show(res);
                toastshown = true;
              }
            },
          });
      },
    });
    this.docValues = [
      { id: 'yes', Name: 'YES' },
      { id: 'no', Name: 'NO' },
    ];

    this.form = this.fb.group({
      nominationItemRecordPickUpEntryRequest: this.fb.array([]),
      remarks: [
        this.nominationData.deliveryRemarks
          ? this.nominationData?.deliveryRemarks
          : null,
      ],
      deliveryCompleted: [null],
    });
    if (this.nominationData?.isDeliveryCompleted === true) {
      this.deliveryCompleted = 'yes';
      this.form.controls['deliveryCompleted'].setValue(this.deliveryCompleted);
      this.uploaddoc = true;
    } else {
      this.deliveryCompleted = 'no';
      this.form.controls['deliveryCompleted'].setValue(this.deliveryCompleted);
      this.uploaddoc = false;
    }
    if (this.nominationData?.recordDeliveryEntries?.length >= 1) {
      this.nominationData.recordDeliveryEntries.forEach((data: any) => {
        this.addDelivery(data);
      });
    } else {
      this.addDelivery('');
    }
    if (this.nominationData?.isDeliveryCompleted) {
      this.uploaddoc = this.nominationData.isDeliveryCompleted;
    } else {
      this.uploaddoc = false;
    }
    if (this.nominationData?.attachments?.length >= 1) {
      this.nominationData.attachments.forEach((e) => {
        let mimeType = this.detectMimeType(e.base64);
        this.fileArray.push({
          fileInBase64: e.base64,
          mime: mimeType,
          name: e.documentName,
          size: e.size,
          downloadURL: e.downloadURL,
        });
      });
    } else {
      this.fileArray = [];
    }
    if(this.nominationData.azureStatus.toLowerCase() === 'in_progress'){
      this.showReload = true;
      if(this.nominationData.triggerTimeStamp){
        const currentTime = new Date();
        const validationTime = new Date(this.nominationData.triggerTimeStamp);
        const timeDifference = Math.abs(currentTime.getTime() - validationTime.getTime());
        const minutesDifference = timeDifference / 1000;
        console.log('Minutes Difference:', minutesDifference);
        if (minutesDifference > this.nominationData.timeoutSeconds) {
          console.log(minutesDifference, this.nominationData.timeoutSeconds);
          // this.showNextButton = true;
          this.showRevalidate = true
        }else{
          // this.showNextButton = false;
          this.showRevalidate = false
        }   
      }
    }
    this.updateFormState()
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['azureValidationRemark'] || changes['azureStatus']) {
      this.updateFormState();
    }
  }
updateFormState(){
    if( (this.nominationData?.isDeliveryCompleted === true)){
      this.form.disable();
    }
    else{
       this.form.enable();
    }
  }
  onValidateClick(): void {
    if(this.fileArray.length === 0){
      this.uploadErr = true;
    }
    // this.showNextButton = true;
    this.SaveRecord(this.form, false, true);
  }

  onRevalidateClick(): void {
    this.SaveRecord(this.form, false, true);
    // this.validateRecords('FINALINVOICE_UC1');
  }

  public uploader: FileUploader = new FileUploader({
    url: ``,
    disableMultipart: false,
    autoUpload: true,
    method: 'post',
    itemAlias: 'attachment',
    allowedFileType: ['xls', 'xlsx', 'pdf', 'jpeg', 'png'],
    maxFileSize: 10485760,
  });

  get nominationItemRecordPickUpEntryRequest() {
    return this.form.controls[
      'nominationItemRecordPickUpEntryRequest'
    ] as FormArray;
  }

  addDelivery(data) {
    this.emptysaveErr = false;
    if (data != '') {
      let deliveryForm = this.fb.group({
        quantityCollected: [
          data.quantityDelivered ? data.quantityDelivered : '',
          Validators.required,
        ],
        dateCollected: [
          data.dateDelivered ? data.dateDelivered : '',
          Validators.required,
        ],
        portsidePartnerTransportEnum: [
          data.deliveryMode ? data.deliveryMode : '',
          Validators.required,
        ],
      });
      this.nominationItemRecordPickUpEntryRequest.push(deliveryForm);
    } else {
      let deliveryForm = this.fb.group({
        quantityCollected: ['', Validators.required],
        dateCollected: ['', Validators.required],
        portsidePartnerTransportEnum: ['', Validators.required],
      });
      this.nominationItemRecordPickUpEntryRequest.push(deliveryForm);
    }
  }
  deleteDelivery(lessonIndex: number) {
    this.nominationItemRecordPickUpEntryRequest.removeAt(lessonIndex);
    if (this.nominationItemRecordPickUpEntryRequest.value.length > 0) {
      this.emptysaveErr = false;
    } else {
      this.emptysaveErr = true;
    }
  }
  closeModal() {
    this.ActiveModal.close();
  }
  get totalQuantityCollected(): number {
    if (!this.nominationItemRecordPickUpEntryRequest?.controls?.length) {
      return 0;
    }

    return this.nominationItemRecordPickUpEntryRequest.controls.reduce(
      (total, row) => {
        const quantityValue = row.get('quantityCollected')?.value;
        const quantity = parseFloat(quantityValue);
        return total + (isNaN(quantity) ? 0 : quantity);
      },
      0,
    );
  }

  private validateRecords(type: 'FINALINVOICE_UC1'): void {
    this.enableLoader = true;
            const validateRequest = {
              nomination: this.nominationData?.nominationNumber,
              nominationKey: this.nominationData?.nominationKey,
              nominationKeyItem: this.nominationData?.nominationItemNumber,
            };

            if (
              !validateRequest.nomination ||
              !validateRequest.nominationKey ||
              !validateRequest.nominationKeyItem
            ) {
              this.toastrService.show(
                'Unable to validate records. Missing nomination details.',
              );
              this.enableLoader = false;
              return;
            }
          this.showNextButton = true;
            this.customProfile.validateRecordPickup(validateRequest, type).subscribe({
              next: (res) => {
          // if (res?.status === 'SUCCESS') {
          // this.showNextButton = true;
                this.enableLoader = false;
                this.revalidateClicked = type === 'FINALINVOICE_UC1';
          // this.toastrService.show(
          //  // res?.message || 'Azure Validation Successful.',
          // );
      //  } else {
         // this.toastrService.show(res?.message || 'Validation failed.');
        //}
        this.enableLoader = false;
                this.getDvlDetails();
              },
              error: () => {
                this.enableLoader = false;
                this.toastrService.show('Validation failed.');
                this.getDvlDetails();
              },
            });
}

cancel() {
    this.ActiveModal.close('cancel');
  }

  SaveRecord(form, openPopup: boolean = false, isValidateSave: boolean = false) {
    this.formData = form.value;
    let formattedvalues = JSON.parse(
      JSON.stringify(this.formData.nominationItemRecordPickUpEntryRequest),
    );
    if (this.formData.nominationItemRecordPickUpEntryRequest.length > 0) {
      this.emptysaveErr = false;
      formattedvalues.forEach((e) => {
        const a = e.dateCollected.split('-');
        e.dateCollected = a[2] + '-' + a[1] + '-' + a[0];
      });
      if (this.formData.deliveryCompleted === 'no') {
        let SaveObject = {
          nomination: this.nominationData.nominationNumber,
          nominationItem: this.nominationData.nominationItemNumber,
          nominationKey: this.nominationData.nominationKey,
          remarks: this.formData.remarks,
          nominationItemRecordPickUpEntryRequest: formattedvalues,
          attachments: this.fileArray,
          code: this.deliveryDetails.code,
          batchId: this.deliveryDetails.batchId,
        };
        this.callForSavingRecordPickup(SaveObject, openPopup,isValidateSave);
      } else {
        this.formData.deliveryCompleted = 'true';
        let SaveObject = {
          nomination: this.nominationData.nominationNumber,
          nominationItem: this.nominationData.nominationItemNumber,
          nominationKey: this.nominationData.nominationKey,
          deliveryCompleted: this.formData.deliveryCompleted,
          remarks: this.formData.remarks,
          nominationItemRecordPickUpEntryRequest: formattedvalues,
          attachments: this.fileArray,
          code: this.deliveryDetails.code,
          batchId: this.deliveryDetails.batchId,
        };
        if (SaveObject?.attachments?.length === 0) {
          this.uploadErr = true;
        } else {
          this.uploadErr = false;
          this.callForSavingRecordPickup(SaveObject, openPopup, isValidateSave);
        }
      }
    } else {
      this.emptysaveErr = true;
    }
  }
  callForSavingRecordPickup(SaveObject, openPopup: boolean = false, isValidateSave: boolean = false) {
    if (openPopup) {
      const ModalRef = this.modalService.open(
        RecordPickupConfirmpopupComponent,
        { centered: true, size: 'lg' },
      );
      ModalRef.componentInstance.deliveryData = SaveObject;
      ModalRef.componentInstance.nominationData = this.nominationData;
      ModalRef.componentInstance.azureStatus = this.azureStatus;
      ModalRef.componentInstance.azureValidationRemark = this.azureValidationRemark;

      ModalRef.result.then((res) => {
        if (res.status == 'SUCCESS') {
          let closeObject = {
            baseProductCode: this.deliveryDetails.baseProductCode,
            checkForClose: false,
            status: res,
          };
          if (this.formData.deliveryCompleted == 'no') {
            closeObject.checkForClose = true;
          } else {
            closeObject.checkForClose = false;
          }
          this.toastrService.show(res.message);
          this.ActiveModal.close(closeObject);
        } else if (res === 'cancel') {
          ModalRef.close();
        } else {
          this.toastrService.show('Error while saving record pick up');
        }
      });
    } else {
      this.enableLoader = true;
      let toastshown = false;
      this.customProfile.saveRecordPickup(SaveObject,isValidateSave).subscribe({
        next: (res) => {
          if (res.status == 'SUCCESS') {
            this.toastrService.show(res.message);
            this.enableLoader = false;
            if(isValidateSave) {
              this.validateRecords('FINALINVOICE_UC1');
              return;
            }
            this.router.navigateByUrl('/').then(() => {
              this.router.navigate(
                [
                  'batches/dvl-tracking-details/' +
                    this.deliveryDetails.batchId,
                ],
                {
                  queryParams: {
                    baseProductCode: this.deliveryDetails.baseProductCode,
                  },
                },
              );
            });
            this.ActiveModal.close();
          }
        },
        error: (err) => {
          this.translationService
            .translate('shipment.erroroccuredmessage')
            .subscribe({
              next: (res) => {
                if (!toastshown) {
                  this.toastrService.show(res);
                  toastshown = true;
                }
              },
            });

          this.enableLoader = false;
          this.ActiveModal.close();
        },
      });
    }
  }
  onDragOver(event) {
    event.preventDefault();
  }

  onDropSuccess(event) {
    event.preventDefault();

    this.onFileChange(event.dataTransfer.files);
  }

  onChange(event) {
    this.onFileChange(event);
  }

  private onFileChange(event) {
    this.uploadErr = false;
    this.filesLength = event.length;
    const file: File = event[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.base64 = reader.result;
      const words = this.base64.split(',')[1];
      const filedata = {
        fileInBase64: words,
        mime: file.type,
        name: file.name,
        size: file.size.toString(),
        donwloadURL: words,
      };
      let fileformatmessage = '';
      let errorMessage = '';
      let fileexceedmsg = '';
      this.translationService.translate('shipment.pdf').subscribe({
        next: (res) => {
          fileexceedmsg = res;
        },
      });
      this.translationService.translate('shipment.fileformatmsg').subscribe({
        next: (res) => {
          fileformatmessage = res;
        },
      });
      if (
        (filedata.mime == 'application/pdf' ||
          filedata.mime == 'image/jpeg' ||
          filedata.mime == 'image/png' ||
          filedata.mime == 'application/vnd.ms-excel' ||
          filedata.mime ==
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') &&
        file.size < 10485760
      ) {
        this.fileArray.push(filedata);
      } else if (
        filedata.mime != 'application/jpeg' &&
        filedata.mime != 'image/pdf' &&
        filedata.mime != 'image/png' &&
        filedata.mime != 'application/vnd.ms-excel' &&
        filedata.mime !=
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        this.toastrService.show(fileformatmessage);
      } else if (file.size > 10485760) {
        this.toastrService.show(fileexceedmsg);
      }
    };
  }
  deleteImage() {
    this.fileName = null;
    this.filesDetail = null;
    this.filesLength = 0;
  }
  removeFile(i: any) {
    this.uploader.queue.splice(i, 1);
    this.fileArray.splice(i, 1);
  }
  selectedDelivery(val) {
    this.deliveryCompleted = val;
  }
  recordelivery(flag) {
    if (flag == 'no') {
      if (this.nominationData.isDeliveryCompleted === true) {
        this.uploaddoc = true;
        this.deliveryCompleted = 'yes';
        this.form.controls['deliveryCompleted'].setValue(
          this.deliveryCompleted,
        );
      } else {
        this.uploaddoc = false;
        this.deliveryCompleted = 'no';
        this.form.controls['deliveryCompleted'].setValue(
          this.deliveryCompleted,
        );
      }
    } else {
      this.uploaddoc = true;
      this.deliveryCompleted = 'yes';
      this.form.controls['deliveryCompleted'].setValue(this.deliveryCompleted);
    }
  }
  removeWarning() {
    this.uploadErr = false;
  }

  getDvlDetails() {
    this.enableLoader = true;
    let toastshown = false;
    this.customProfileService.dvlTrackingDetails(this.passingArray).subscribe(
      (data) => {
        this.enableLoader = false;
        if (data) {
          this.dvldDetails = data;
          if (
            this.dvldDetails.nominationItems &&
            this.dvldDetails.nominationItems.length > 0
          ) {
            this.nominationData = this.dvldDetails.nominationItems.filter(
              (item) => {
                return (
                  item.nominationNumber ===
                  this.nominationData.nominationNumber
                );
              },
            )?.[0];
          //  this.showNextButton = true;
           this.azureStatus = this.nominationData.azureStatus;
           this.azureValidationRemark = this.nominationData.azureValidationRemark;
           this.isInvoiceCreationSuccess = this.nominationData.isInvoiceCreationSuccess;
            if(this.azureStatus.toLowerCase() === 'in_progress'){
              this.showReload = true;
            }
            else{
              this.showReload = false;
            }
        this.updateFormState()
          }
        } else {
          this.translation
            .translate('shipment.emptyerrormessage')
            .subscribe((res) => {
              if (!toastshown) {
                this.toastrService.show(res);
                toastshown = true;
              }
            });
        }
      },
      (err) => {
        this.translation
          .translate('shipment.erroroccuredmessage')
          .subscribe((res) => {
            if (!toastshown) {
              this.toastrService.show(res);
              toastshown = true;
            }
          });
        this.enableLoader = false;
      },
    );
  }
}
